module.exports = __webpack_public_path__ + "img/41_22.e05c58cb.png";